/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PerformerContractType {
    Exhibit1 = 'Exhibit1',
    Exhibit2 = 'Exhibit2',
}
